'use client';

import { memo, type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

export type SectionLabelProps = {
  children: ReactNode;
  className?: string;
};

export const SectionLabel = memo(({ children, className }: SectionLabelProps) => (
  <h3 className={cn('font-bold text-10 text-neutral-10 uppercase tracking-wide', className)}>{children}</h3>
));

SectionLabel.displayName = 'SectionLabel';
